export function matchesCounterpartyBookSearch(
    values: Array<string | null | undefined>,
    search: string,
): boolean {
    const query = search.trim().toLowerCase();
    if (!query) {
        return true;
    }

    return values.some((value) => value?.toLowerCase().includes(query));
}
